import { routes } from '@/router'
import { languages } from '@/assets/js/$/i18n'

export function getFlatRoutes(inputRoutes) {
  let unflattedRoutes = inputRoutes || routes
  let flattedRoutes = []

  unflattedRoutes.forEach(flatten)

  return flattedRoutes

  function flatten(route) {
    flattedRoutes.push(route)

    if (route.children !== undefined && route.children.length > 0) {
      route.children.forEach(flatten)
    }
  }
}

export function getRouteByName(routeName = '', inputRoutes) {
  let unflattedRoutes = inputRoutes || routes
  let flattedRoutes = getFlatRoutes(unflattedRoutes)

  return flattedRoutes.find(route => route.name === routeName)
}

export function getLocalizationInExcludes(locale = '') {
  let loose = locale.substr(0, 2)

  return {
    include: loose.charAt(0).toUpperCase() + loose.slice(1),
    exclude: new RegExp(
      `(${languages.available.loose
        .filter(lang => lang !== loose)
        .map(lang => lang.charAt(0).toUpperCase() + lang.slice(1))
        .join('|')})([0-9]+)?$`
    )
  }
}

export function localize(data, inclusion = '', exclusion = new RegExp('')) {
  if (data !== null && data !== undefined) {
    if (Array.isArray(data)) {
      return localizeArray(data, inclusion, exclusion)
    } else if (typeof data === 'object' || data instanceof Object) {
      return localizeObject(data, inclusion, exclusion)
    } else {
      return data
    }
  }

  function localizeObject(object, inclusion = '', exclusion = new RegExp('')) {
    return Object.keys(object).reduce((localized, propertyName) => {
      if (object[propertyName] !== undefined && !exclusion.test(propertyName)) {
        if (Array.isArray(object[propertyName])) {
          localized[propertyName.replace(inclusion, '')] = localizeArray(
            object[propertyName],
            inclusion,
            exclusion
          )
        } else if (
          (object[propertyName] !== null &&
            typeof object[propertyName] === 'object') ||
          object[propertyName] instanceof Object
        ) {
          localized[propertyName.replace(inclusion, '')] = localizeObject(
            object[propertyName],
            inclusion,
            exclusion
          )
        } else {
          if (propertyName == 'registrationDeadline') {
            localized[propertyName] = object[propertyName]
          } else {
            localized[propertyName.replace(inclusion, '')] = object[propertyName]
          }
        }
      }

      return localized
    }, {})
  }

  function localizeArray(array, inclusion = '', exclusion = new RegExp('')) {
    return array.map((item, index) => {
      if (Array.isArray(array[index])) {
        return localizeArray(array[index], inclusion, exclusion)
      } else if (
        typeof array[index] === 'object' ||
        array[index] instanceof Object
      ) {
        return localizeObject(array[index], inclusion, exclusion)
      } else {
        return array[index]
      }
    })
  }
}

export function numberFormatter(number = null, options = {}) {
  let o = Object.assign(
    {
      seperator: {
        repeat: 3,
        symbol: "'"
      },
      fixed: 2
    },
    options
  )

  let formatted = number

  if (number === null || isNaN(number)) {
    return number
  }

  if (o.fixed) {
    formatted = formatted.toFixed(o.fixed)
  }

  if (o.seperator && o.seperator.repeat && o.seperator.symbol) {
    formatted = formatted
      .toString()
      .replace(
        new RegExp(`(\\d)(?=(\\d{${o.seperator.repeat}})+(?!\\d))`, 'g'),
        `$1${o.seperator.symbol}`
      )
  }

  return formatted
}

export default {
  getFlatRoutes,
  getRouteByName,
  getLocalizationInExcludes,
  localize,
  numberFormatter
}
